import { useAdministrativeContext } from "../../../../../../pages/administrativePanel/administrativePanelContext"
import { useState, useEffect, useCallback } from "react"
import { useAuth } from "../../../../../../context/AuthContext"
import { formatMoney } from '../../../../../../Utils/formatMoney'
import { toast } from "react-toastify"
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts"
import { api } from "../../../../../../services/api"
import { SpaceLoader } from "../../../../../loaders/spaceLoader"

import { TooltipContent } from './style'


export function SalesPeaksGraphic() {
  const [salesPeaksDatas, setSalesPeaksDatas] = useState([])
  const [isSalesPeaksLoading, setIsSalesPeaksLoading] = useState(true)


  const { 
    listBusinessToFilter, 
    startDate, 
    endDate,
    listSalesChannelsId 
  } = useAdministrativeContext()


  const { signOut } = useAuth()


  const fetchData = useCallback(async () => {
    setIsSalesPeaksLoading(true)
    let obj = {
      startDate: startDate,
      endDate: endDate,
      business: listBusinessToFilter,
      salesChannels: listSalesChannelsId
    }

   
      try{
          await api.post('/getSalesPeaksGraphic' , obj, {
              headers: {
                  'Content-Type': 'application/json',
                  token: localStorage.getItem('@Inoveclube:token')
              }
          }).then(response => setSalesPeaksDatas(response.data))

          setIsSalesPeaksLoading(false)

      }catch(error){
          if(error.response){
              if(error.response.status === 401 || error.response.status === 500){
                signOut()
                toast.warning('Sua sessão foi expirada')
              }else{
                toast.error(error.response.data.message)
              }
          }else{
              toast.error(error.message)
          }        
      }
  }, [signOut, endDate, startDate, listBusinessToFilter, listSalesChannelsId])

  
  useEffect(() =>{
    if(startDate !== '' && endDate !== '')
      fetchData()

      return () => {
        setSalesPeaksDatas([])
      }

  }, [fetchData, startDate, endDate])


  
  if(isSalesPeaksLoading){
    return  <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/> 
  }else{
    return(
      <>
        {
          salesPeaksDatas.length > 0 ?
          <ResponsiveContainer  width="98%" height="100%" maxHeight={700}>
            <AreaChart data={salesPeaksDatas} margin={{top: 30}}>

                

                <defs>
                  <linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%"  stopColor="#2e9699" stopOpacity={0.9}/>
                      <stop offset="75%"  stopColor="#2e9699" stopOpacity={0.4}/>
                  </linearGradient>
                </defs>


                <Area 
                  dataKey="$" 
                  stroke="#2e9699" 
                  fill="url(#color2)" 
                  strokeWidth={1.2}
                />


                <XAxis 
                  dataKey="hour" 
                  axisLine={false} 
                  tickLine={false} 
                  stroke="var(--colorFontsCardsDashboard)" 
                  fontSize="0.75rem"
                />

                <YAxis 
                  axisLine={false} 
                  tickLine={false} 
                  tickCount={6} 
                  stroke="var(--colorFontsCardsDashboard)" 
                  padding={{bottom: 5}} 
                  width={65}
                  fontSize="0.85rem" 
                  tickFormatter={number => (
                      number >= 1000 && number < 1000000 ? `R$${number/1000}K` : 
                      number >= 1000000 && number < 1000000000 ? `R$${number/1000000}M` :
                      number >= 1000000000 ? `R$${number/1000000000}B` :      
                      `R$${number.toFixed(2)}`
                  )} 
                />

                <Tooltip content={<CustomTooltip />}/>

                <CartesianGrid 
                  opacity={0.2} 
                  vertical={false} 
                  stroke="var(--colorFontsCardsDashboard)" 
                />

            </AreaChart>
          </ResponsiveContainer>
          :<p>Nenhuma informação</p>
        }
      </>
    )
  }
}

export function CustomTooltip({ active, payload, label }) {
  if(active){
    return(
      <TooltipContent>

        <h4>{label}</h4>
        {payload?.map((information, index) =>(
          <p key={index}>
           {
             formatMoney(information.value)
            }
          </p>
        ))}
        
      </TooltipContent>
    )
  }
  return null
}